// CategoriesList.tsx
import React from 'react';
// import { Category } from './types';
import './CategoriesList.scss';

interface CategoriesListProps {
  // categories: Category[];
  onCategoryClick: (categoryName: string) => void;
}

const CategoriesList: React.FC<CategoriesListProps> = ({ categories, onCategoryClick }) => {
  return (
    <div className="categories card">
      <ul className="categories-list">
        {categories.map((category) => (
          <CategoryItem
            key={category.name}
            category={category}
            onClick={() => onCategoryClick(category.name)}
          />
        ))}
      </ul>
    </div>
  );
};

interface CategoryItemProps {
  category: Category;
  onClick: () => void;
}

const CategoryItem: React.FC<CategoryItemProps> = ({ category, onClick }) => {
  const { currentLabel } = category;

  if (!currentLabel) {
    return null;
  }

  return (
    <li className="categories-list__item" onClick={onClick}>
      <div className="categories-list__block">
        <div className="categories-list__category">
          <div className="category">
            <span className="name">{category.name}</span>
          </div>
          <div>Rank</div>
        </div>
        
        <div className="categories-list__label">
          <div className="name">{currentLabel.name}</div>
          <div className="ranking">
            <span className="rank">{currentLabel.rank}/</span>
            <span className="total">{category.labels.length}</span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default CategoriesList;